
define('text!presentation/common/protectedContent/views/protectedContent.html',[],function () { return '<div class="protected-content" data-bind="i18n: \'protectedContent\'">\n\n</div>';});

